// extracted by mini-css-extract-plugin
export default {"emojiIcon":"styles-module__emojiIcon--oLPDd","emojiContainer":"styles-module__emojiContainer--EDpzK"};